import type React from 'react';

const apiUrl = process.env.BUN_PUBLIC_API_URL ?? '';

interface AppImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  fileId: string;
  type?: 'original' | 'thumbnail';
}
export const AppImage = ({ fileId, type = 'thumbnail', ...props }: AppImageProps) => {
  return (
    // biome-ignore lint/a11y/useAltText: app-image component
    <img
      {...props}
      src={`${apiUrl}/api/files/${fileId}/${type === 'original' ? 'original' : 'thumbnail'}`}
    />
  );
};
